import React, { useState } from "react";
import CardNavigation from "../../components/CardNavigation/CardNavigation";
import EducationCard from "../../components/Education/EducationCard";
import Slides from "../../components/Slides/Slides";
import { useLanguage } from "../../Context/LanguageContext";
import education from "../../myData/education.js";
import "../Education/Education.css";

function Education() {
  const [order, setOrder] = useState(0);
  const { language } = useLanguage();

  return (
    <div className="container">
      <h2
        className={language === "arabic" ? "page-title arabic" : "page-title"}
      >
        {language === "english"
          ? "Education"
          : language === "dutch"
          ? ""
          : "التعليم الأكاديمي"}
      </h2>
      <CardNavigation
        children={<EducationCard education={education[language][order]} />}
        setOrder={setOrder}
        order={order}
        maxOrder={education[language].length - 1}
      />
      <Slides slides={education[language]} order={order} setOrder={setOrder} />
    </div>
  );
}

export default Education;
